import React from 'react';
import NavbarTemplate from '../pages/components/NavbarTemplate';
import InfoPenawar from '../pages/InfoPenawar';

export default function LayoutInfoPenawar() {
  return (
    <>
      <NavbarTemplate name="Info Penawar" />
      <InfoPenawar />
    </>
  );
}
